import {
  createMultiStyleConfigHelpers,
  MultiStyleType,
  StyleThemingProps,
} from '~/utils/chakraUtils'
import { mergeMultiStyleConfig } from '~/utils/styleHelpers'

const ExtensionSelectorParts = [
  'container',
  'header',
  'headerText',
  'extensionBadge',
  'extensionBadgeText',
] as const

const helpers = createMultiStyleConfigHelpers(ExtensionSelectorParts)
export const ExtensionSelector = helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      justifyContent: 'flex-end',
      alignItems: 'center',
      width: '100%',
      padding: '1rem 0rem',
      gap: '8px',
    },
    header: {
      width: '100%',
      display: 'flex',
      padding: '0.5rem 0.75rem 0rem 0.75rem',
      alignItems: 'flex-start',
      gap: '0.5rem',
      alignSelf: 'stretch',
      flexDirection: 'column',
    },
    headerText: {
      color: 'fg.default',
      fontSize: '0.875rem',
      fontWeight: '700',
    },
    extensionBadge: {
      display: 'flex',
      height: '24px',
      padding: '0 8px',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '8px',
      borderRadius: '50px',
      border: '2px solid',
      borderColor: 'border.inverted',
    },
    extensionBadgeText: {
      fontSize: '0.875rem',
      fontWeight: '600',
    },
  },
})

export const useExtensionSelectorStyles = (props?: StyleThemingProps) => {
  return mergeMultiStyleConfig(ExtensionSelector, props) as MultiStyleType<
    typeof ExtensionSelectorParts
  >
}
